import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ol class=\"{{local-class \"list\" from=\"@qonto/ui-kit/components/timeline.module.css\"}}\" ...attributes>\n  {{#each @steps as |step index|}}\n    <Timeline::Step @step={{step}} />\n  {{/each}}\n</ol>", {
  moduleName: "@qonto/ui-kit/components/timeline.hbs"
});